<template>
  <div class="sorter-curve-dashboard">
    <!-- Snackbar de Feedback -->
    <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
        bottom
    >
      <div class="d-flex align-center">
        <v-icon left :color="snackbar.iconColor">{{ snackbar.icon }}</v-icon>
        <span>{{ snackbar.message }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.show = false"
            :color="snackbar.iconColor"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Formulário -->
    <sorter-curve-formulario
        ref="formulario"
        :loading="loadingAnalise"
        @buscar-clientes="buscarClientes"
        @criar-analise="criarAnalise"
        class="mb-5"
    />

    <!-- Tabela -->
    <sorter-curve-tabela
        :historico="historico"
        :filiais="filiaisFiltro"
        :loading="loadingHistorico"
        :loading-p-d-f="loadingPDF"
        @filtro-alterado="onFiltroAlterado"
        @atualizar="carregarHistorico"
        @visualizar-pdf="visualizarPDF"
        @solicitar-reavaliacao="solicitarReavaliacao"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import SorterCurveFormulario from './Widgets/ConsultaCreditoFormulario.vue';
import SorterCurveTabela from './Widgets/ConsultaCreditoTabela.vue';
import mixinFilial from "../../util/mixinFilial";

export default {
  name: 'SorterCurveIndex',
  mixins: [mixinFilial],
  components: {
    SorterCurveFormulario,
    SorterCurveTabela
  },

  data() {
    return {
      loadingAnalise: false,
      historico: [],
      loadingHistorico: false,
      loadingPDF: null,
      filtros: {
        idfilial: '',
        dataInicio: '',
        dataFim: ''
      },

      snackbar: {
        show: false,
        message: '',
        color: 'error',
        icon: 'mdi-alert-circle',
        iconColor: 'white',
        timeout: 6000,
      },
    };
  },

  computed: {
    ...mapState(['backendUrl', 'usuario']),
    filiaisFiltro() {
      if (this.filiais.lista) {
        return this.filiais.lista.filter((v) => {
          return (
              v.idfilial !== 4 &&
              v.idfilial !== 6 &&
              v.idfilial !== 12 &&
              v.idfilial !== 13 &&
              v.idfilial !== 25 &&
              v.idfilial !== 28 &&
              v.idfilial !== 29 &&
              v.idfilial !== 33 &&
              v.idfilial !== 37 &&
              v.idfilial !== 39 &&
              v.idfilial !== 40 &&
              v.idfilial !== 42 &&
              v.idfilial !== 43
          );
        });
      } else {
        return [];
      }
    },
  },

  mounted() {
    const hoje = new Date();
    const dataInicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1).toISOString().substr(0, 10);
    const dataFim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0).toISOString().substr(0, 10);

    this.filtros = {
      dataInicio: `${dataInicio} 00:00:00`,
      dataFim:    `${dataFim} 23:59:59`,
    };

    this.carregarHistorico();
  },

  methods: {
    // ── Feedback ─────────────────────────────────────────────

    showSnackbar(message, type = 'error') {
      const config = {
        error:   { color: 'error',   icon: 'mdi-alert-circle',  iconColor: 'white' },
        success: { color: 'success', icon: 'mdi-check-circle',  iconColor: 'white' },
        warning: { color: 'warning', icon: 'mdi-alert',         iconColor: 'white' },
        info:    { color: 'info',    icon: 'mdi-information',   iconColor: 'white' },
      };

      const c = config[type] || config.error;
      this.snackbar = {
        show: true,
        message,
        color:     c.color,
        icon:      c.icon,
        iconColor: c.iconColor,
        timeout:   type === 'error' ? 8000 : 6000,
      };
    },

    handleSessionExpired() {
      this.showSnackbar('Sessão expirou! A página será recarregada em 5 segundos...', 'warning');
      setTimeout(() => window.location.reload(), 5000);
    },

    handleRequestError(error, defaultMessage) {
      if (error.response) {
        const status    = error.response.status;
        const errorData = error.response.data;

        if (errorData && errorData.erro) {
          const erroMsg = errorData.erro.trim().toLowerCase();
          if (erroMsg.includes('token') && erroMsg.includes('inválido')) {
            this.handleSessionExpired();
            return;
          }
        }

        if (status === 401 || status === 403) {
          this.handleSessionExpired();
        } else if (status === 404) {
          this.showSnackbar('Serviço não encontrado. Verifique a URL da API.', 'error');
        } else if (status === 500) {
          this.showSnackbar('Erro interno do servidor. Tente novamente mais tarde.', 'error');
        } else {
          this.showSnackbar(`${defaultMessage}: ${errorData?.erro || error.message}`, 'error');
        }
      } else if (error.request) {
        this.showSnackbar('Erro de conexão. Verifique sua internet e tente novamente.', 'error');
      } else {
        this.showSnackbar('Ocorreu um erro inesperado. Tente novamente.', 'error');
      }
    },

    // ── Clientes ─────────────────────────────────────────────

    async buscarClientes(valor, buscaId) {
      try {
        const response = await axios.post(`${this.backendUrl}cliente/listar`, {
          limit:           30,
          offset:          0,
          tipo:            this.permissao('sortercurve_filtro_colaboradores') ? "" : "'C','A','F','T'",
          busca:           valor || null,
          somente_clientes: !this.permissao('sortercurve_filtro_colaboradores'),
        });

        if (response.data && response.data.erro) {
          const erroMsg = response.data.erro.trim().toLowerCase();
          if (erroMsg.includes('token') && erroMsg.includes('inválido')) {
            this.handleSessionExpired();
            return;
          }
          this.showSnackbar(`Erro: ${response.data.erro}`, 'error');
          this.$refs.formulario.setClientes([], buscaId);
          return;
        }

        this.$refs.formulario.setClientes(response.data.lista || [], buscaId);
      } catch (error) {
        console.error('Erro ao buscar clientes:', error);
        this.handleRequestError(error, 'Erro ao buscar clientes');
        this.$refs.formulario.setClientes([], buscaId);
      }
    },

    // ── Análise ──────────────────────────────────────────────

    async criarAnalise(dados) {
      this.loadingAnalise = true;
      try {
        const response = await axios.post(`${this.backendUrl}sortercurve`, {
          acao:        'criar',
          idclifor:    dados.idclifor,
          valor_venda: dados.valor_venda,
        });

        if (response.data && response.data.erro) {
          const erroMsg = response.data.erro.trim().toLowerCase();
          if (erroMsg.includes('token') && erroMsg.includes('inválido')) {
            this.handleSessionExpired();
            return;
          }
          this.showSnackbar(`Erro: ${response.data.erro}`, 'error');
          return;
        }

        this.showSnackbar(response.data.mensagem || 'Análise criada com sucesso!', 'success');
        this.carregarHistorico();
        this.$refs.formulario.limparFormulario();
      } catch (error) {
        console.error('Erro ao criar análise:', error);
        if (error.response?.status === 409) {
          this.$refs.formulario.mostrarErroBloqueio(error.response.data?.erro || 'Análise bloqueada nos últimos 30 dias.')
        } else {
          this.handleRequestError(error, 'Erro ao criar análise de crédito');
        }
      } finally {
        this.loadingAnalise = false;
      }
    },

    // ── Histórico ────────────────────────────────────────────

    async carregarHistorico() {
      this.loadingHistorico = true;
      try {
        const response = await axios.post(`${this.backendUrl}sortercurve`, {
          acao:        'listar',
          id_filial:   this.filtros.idfilial,
          data_inicio: this.filtros.dataInicio,
          data_fim:    this.filtros.dataFim,
        });

        if (response.data && response.data.erro) {
          const erroMsg = response.data.erro.trim().toLowerCase();
          if (erroMsg.includes('token') && erroMsg.includes('inválido')) {
            this.handleSessionExpired();
            return;
          }
          this.showSnackbar(`Erro: ${response.data.erro}`, 'error');
          this.historico = [];
          return;
        }

        this.historico = response.data || [];
      } catch (error) {
        console.error('Erro ao carregar histórico:', error);
        this.handleRequestError(error, 'Erro ao carregar histórico');
        this.historico = [];
      } finally {
        this.loadingHistorico = false;
      }
    },

    // ── PDF ──────────────────────────────────────────────────

    async visualizarPDF(analiseID, detalhado) {
      this.loadingPDF = `${analiseID}-${detalhado ? 'detalhado' : 'simples'}`;

      try {
        const response = await axios.post(`${this.backendUrl}sortercurve`, {
          acao:       detalhado ? 'buscar_pdf_detalhado' : 'buscar_pdf_simplificado',
          analise_id: analiseID,
        });

        if (response.data && response.data.erro) {
          const erroMsg = response.data.erro.trim().toLowerCase();
          if (erroMsg.includes('token') && erroMsg.includes('inválido')) {
            this.handleSessionExpired();
            return;
          }
          this.showSnackbar(`Erro: ${response.data.erro}`, 'error');
          return;
        }

        const pdfBase64    = response.data.pdf_base64;
        const byteChars    = atob(pdfBase64);
        const byteNumbers  = new Array(byteChars.length);
        for (let i = 0; i < byteChars.length; i++) byteNumbers[i] = byteChars.charCodeAt(i);
        const blob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/pdf' });
        const url  = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        setTimeout(() => window.URL.revokeObjectURL(url), 60000);
      } catch (error) {
        console.error('Erro ao visualizar PDF:', error);
        this.handleRequestError(error, 'Erro ao visualizar PDF');
      } finally {
        this.loadingPDF = null;
      }
    },

    // ── Reavaliação ──────────────────────────────────────────

    async solicitarReavaliacao(dados) {
      const { resolve, reject, ...payload } = dados;
      try {
        const response = await axios.post(`${this.backendUrl}sortercurve/reavaliacao`, {
          analise_id:    payload.analise_id,
          justificativa: payload.justificativa,
        });

        if (response.data && response.data.erro) {
          const erroMsg = response.data.erro.trim().toLowerCase();
          if (erroMsg.includes('token') && erroMsg.includes('inválido')) {
            this.handleSessionExpired();
            reject(new Error('sessao_expirada'));
            return;
          }
          this.showSnackbar(`Erro: ${response.data.erro}`, 'error');
          reject(new Error(response.data.erro));
          return;
        }

        this.showSnackbar(
            response.data.mensagem || 'Reavaliação solicitada com sucesso!',
            'success'
        );

        const idx = this.historico.findIndex(h => h.analise_id === payload.analise_id);
        if (idx !== -1) {
          this.$set(this.historico, idx, {
            ...this.historico[idx],
            decisao:       response.data.decisao_codigo ?? 7,
            decisao_texto: response.data.decisao_texto  ?? 'Reanálise',
            status:        'PENDENTE',
          });
        }

        resolve();
      } catch (error) {
        if (error.message !== 'sessao_expirada') {
          this.handleRequestError(error, 'Erro ao solicitar reavaliação');
        }
        reject(error);
      }
    },

    // ── Filtros ──────────────────────────────────────────────

    onFiltroAlterado(filtros) {
      this.filtros = filtros;
      this.carregarHistorico();
    },
  },
};
</script>

<style scoped>
.sorter-curve-dashboard {
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>